class ResultInstance<T, K> {
	constructor(
		public readonly ok: T,
		public readonly err: K,
	) {
		// Empty
	}
}

export type Result<T = void, K = Error> =
	| {
			ok: T;
			err: null;
	  }
	| {
			ok: null;
			err: K;
	  };

export type AsyncResult<T = void, K = Error> = Promise<Result<T, K>>;

export function Ok<T, _K>(val: T): Result<T, _K>;
export function Ok<T extends void, _K>(val?: T): Result<T, _K>;
export function Ok<T, _K>(value: T): Result<T, null> {
	return new ResultInstance(value, null);
}

export function Err<_T, K>(value: K): Result<null, K> {
	return new ResultInstance(null, value);
}
